import React, { useState, useEffect } from "react";
import DefaultQuestion from "../../../Create_Assessment/Create_Question/Create_Q_Type/DefaultQuestion";
import QuestionList from "../../../Create_Assessment/Preview_Question_List/QuestionListHomework";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../../axios";

const TeacherId = localStorage.getItem("Teacher_id");
const jsonTeacherId = JSON.parse(TeacherId);
const EditScheduleHw = () => {
  //Added this state by kuldeep
  const navigate = useNavigate();
  const { state } = useLocation()
  const [isInProgress, setIsInProgress] = useState(false);

  const [assessmentDetails, setAssessmentDetails] = useState({
    name: null,
    description: null,
    teacher_id: null,
    type_id: null,
    standard_id: null,
    section_id: null,
    subject_id: null,
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: null,
    questions: [],
  });

  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;
  const [click, setClick] = useState(false);
  const [questions, setQuestions] = useState([]);
  useEffect(() => {
    const getAssessment = async () => {
      let res = await axios.get(`/api/v1/homework/get/${state.homework_id}`);
      if (res) {
        const {
          id,
          name,
          description,
          teacher_id,
          type_id,
          subject_id,
          section_id,
          standard_id,
          tags,
          total_duration,
        } = res?.data?.data;

        setAssessmentDetails((prev) => ({
          ...prev,
          id,
          name,
          description,
          teacher_id: teacher_id?.id,
          type_id: type_id?.id,
          subject_id,
          section_id,
          standard_id,
          tags,
          total_duration,
        }));

        res.data.data.questions.map((question) =>
          setQuestions((prev) => [
            ...prev,
            {
              standard_id: question?.standard?.id,
              section_id: question?.section?.id,
              subject_id: question?.subject?.id,
              book_id: question?.book?.id,
              chapter_id: question?.chapter?.id,
              type_id: question?.type?.id,
              question_type: String(question?.type?.is_manually_graded),
              domain_id: question?.domain?.id,
              skill_id: question?.skill?.id,
              difficulty_level: question?.difficulty_level?.id,
              title: question?.title,
              correct_score: question?.correct_score,
              is_mandatory: question?.is_mandatory,
              add_to: question?.add_to,
              attachments: question?.attachments,
              options: question?.options,
              correct_answers: question?.correct_answers,
            },
          ])
        );
      }
    };
    getAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addMoreQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        standard_id: standard_id ? standard_id?.id : null,
        subject_id: subject_id ? subject_id?.id : null,
        section_id: section_id ? section_id?.id : null,
        book_id: "633c5ac7629a3af66952fa5c",
        chapter_id: null,
        question_type: "null",
        type_id: null,
        domain_id: null,
        skill_id: null,
        difficulty_level: null,
        title: null,
        correct_score: null,
        is_mandatory: false,
        add_to: null,
        attachments: [],
        options: [
          {
            key: "A",
            value: null,
          },
          {
            key: "B",
            value: null,
          },
        ],
        correct_answers: [
          {
            option_key: null,
            value: null,
            reason_for_answer: {
              explanation: null,
            },
          },
        ],
      },
    ]);
  };
  const handleCreateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      total_duration: assessmentDetails.total_duration,
      questions: questions,
    };
    console.log(newAssessment);
    try {
      let res = await axios.put(`/api/v1/homework/update/${state.homework_id}`, newAssessment);
      res && navigate("/PublishedHomework");
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const checkAllDataField = () => {
    if (
      !questions[questions.length - 1]?.title ||
      !questions[questions.length - 1]?.skill_id ||
      !questions[questions.length - 1]?.domain_id ||
      !questions[questions.length - 1]?.type_id ||
      !questions[questions.length - 1]?.chapter_id ||
      !questions[questions.length - 1]?.correct_score ||
      !questions[questions.length - 1]?.difficulty_level
    ) {
      return true;
    } else {
      return false;
    }
  };

  const findTotalMarks = () => {
    return questions.reduce((acc, curr) => acc + Number(curr.correct_score), 0);
  };

  return (
    <>
      <div className="d-flex align-items-center  ">
        <img
          onClick={() => window.history.back()}
          style={{ cursor: "pointer" }}
          src="/images/Back Arrow.svg"
          alt=""
        ></img>
        <span
          onClick={() => window.history.go(-2)}
          className="published_hw_file_path1"
        >
          &nbsp; Homework /&nbsp;
        </span>
        <span className="published_hw_file_path2">{name}</span>
      </div>
      <div className="mt-2 ms-1 published_tittle_heading">{description}</div>

      <div className="hw_question_container">
        <div className=" col-12 gap-2 p-0 flex-wrap mt-2 d-flex justify-content-between align-items-center">
          <div className="ms-1 col-md-2 p-0 hw_header_subject_name">
            {subject_id?.name}
          </div>
        </div>

        {questions.length > 0 &&
          questions.map((question, index) => (
            <DefaultQuestion
              key={index}
              nextQuestion={index}
              question={question}
              setQuestions={setQuestions}
              assessmentDetails={assessmentDetails}
              qArr={questions}
            />
          ))}

        {!checkAllDataField() && (
          <div className="mt-2 d-flex align-items-center justify-content-center">
            <button
              id="Add-options-btn"
              className="btn  add_question_button"
              type="button"
              onClick={addMoreQuestion}
            >
              <img src="/images/add button.svg" className="mx-1" alt=""></img>
              Add question
            </button>
          </div>
        )}

        <div className="mt-2 me-2 d-grid gap-2 d-md-flex justify-content-md-end mt-5 ">
          <button
            onClick={handleCreateAssessment}
            disabled={checkAllDataField()}
            className="btn draft_button"
          >
            Save as Draft
          </button>
          <button
            disabled={checkAllDataField()}
            className="btn  next_button"
            onClick={(e) => setClick(true)}
          >
            Next
          </button>
        </div>
      </div>

      {click && (
        <QuestionList
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          isScheduledEditing={true}
          total_marks={findTotalMarks()}
        />
      )}
      {isInProgress && (
        <div className="loader_bg">
          <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}
      {/* {delete1 && (
        <Delete
          isForDraft={true}
          assessmentId={assessmentId}
          setDelete={setDelete1}
        />
      )} */}
    </>
  );
};

export default EditScheduleHw;
